export default {
  text: 'Laden...',
};
